export const SET_ESTA_CADASTRANDO_CARTAO = 'FORMASPAGAMENTO/SET_ESTA_CADASTRANDO_CARTAO'
export const SET_FORMA_PAGAMENTO_CLIENTE = 'FORMASPAGAMENTO/SET_FORMA_PAGAMENTO_CLIENTE'
